import story_img from '../../assets/Image/story_img.webp'
import team_img_1 from '../../assets/Image/team_img_1.webp'
import team_img_2 from '../../assets/Image/team_img_2.webp'
import team_img_3 from '../../assets/Image/team_img_3.webp'
import team_img_4 from '../../assets/Image/team_img_4.webp'
import team_img_5 from '../../assets/Image/team_img_5.webp'
import team_img_6 from '../../assets/Image/team_img_6.webp'
import team_img_7 from '../../assets/Image/team_img_7.webp'
import team_img_8 from '../../assets/Image/team_img_8.webp'
import team_img_9 from '../../assets/Image/team_img_9.webp'
import team_img_10 from '../../assets/Image/team_img_10.webp'
import Partner_img1 from '../../assets/Image/Partner_img1.webp'
import Partner_img2 from '../../assets/Image/Partner_img2.webp'
import Partner_img3 from '../../assets/Image/Partner_img3.webp'
import Partner_img4 from '../../assets/Image/Partner_img4.webp'
import Partner_img5 from '../../assets/Image/Partner_img5.webp'
import Partner_img6 from '../../assets/Image/Partner_img6.webp'
import Partner_img7 from '../../assets/Image/Partner_img7.webp'
import Partner_img8 from '../../assets/Image/Partner_img8.png'
import Partner_img9 from '../../assets/Image/Partner_img9.webp'
import Partner_img10 from '../../assets/Image/Partner_img10.webp'
import switzerland_img from '../../assets/Image/Switzerland_img.svg'
import about_global_img from '../../assets/Image/about_global_img.webp'
import { GrLinkedinOption } from 'react-icons/gr';
import { FaTelegramPlane, FaMapPin } from 'react-icons/fa'
import { CiFlag1 } from 'react-icons/ci'
import { BsClock } from 'react-icons/bs'
import { EmailOutlined } from '@mui/icons-material'
import { Schedule } from '../../Component'


const About = () => {
    let team_obj = [
        {
            img: team_img_1,
            name: 'Alexandros S.',
            pos: 'Co-Founder'
        },
        {
            img: team_img_2,
            name: 'Maximilian S.',
            pos: 'Co-Founder'
        },
        {
            img: team_img_3,
            name: 'Chris M.',
            pos: 'Partner'
        },
        {
            img: team_img_4,
            name: 'Legendary',
            pos: 'Web3 Lead'
        },
        {
            img: team_img_5,
            name: 'Clemens O.',
            pos: 'Technology Advisor'
        },
        {
            img: team_img_6,
            name: 'Kwaku S.',
            pos: 'Regional Advisor Africa'
        },
        {
            img: team_img_7,
            name: 'Lukas F.',
            pos: 'Project Manager'
        },
        {
            img: team_img_8,
            name: 'Florian H.',
            pos: 'Project Manager'
        },
        {
            img: team_img_9,
            name: 'Pradyum R.',
            pos: 'Research Analyst'
        },
        {
            img: team_img_10,
            name: 'Utkarsh H.',
            pos: 'Technology Analyst'
        },

    ]
    let partner_obj = [
        {
            img: Partner_img1,
            width: '120px'
        },
        {
            img: Partner_img2,
            width: '140px'
        },
        {
            img: Partner_img3,
            width: '120px'
        },
        {
            img: Partner_img4,
            width: '140px'
        },
        {
            img: Partner_img5,
            width: '110px'
        },
        {
            img: Partner_img6,
            width: '190px'
        },
        {
            img: Partner_img7,
            width: '140px'
        },
        {
            img: Partner_img8,
            width: '130px'
        },
        {
            img: Partner_img9,
            width: '130px'
        },
        {
            img: Partner_img10,
            width: '60px'
        },
    ]
    return (
        <>
            <div className="about_main_div">
                <div className="about_inner_div1">
                    <div className='solution_list_text_div' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='100'>
                        <h4>OUR</h4>
                        <b>COMPANY</b>
                    </div>
                    <p className="about_p">
                        Block Consult is a Swiss based consulting firm which provides value by creating holistic Web3 concepts tailored to the individual needs of any project
                    </p>
                </div>
                <div className="about_inner_div2">
                    <div className='story_div'>
                        <div className='about_img_div' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='100'>
                            <img src={story_img} alt="" />
                        </div>
                        <div className='story_inner_div'>
                            <div className='about_h4_div'>
                                <h4>OUR</h4>
                                <b>STORY</b>
                            </div>
                            <div className='about_p1'>
                                <p>
                                    The company was founded due to our passion for innovation and our in-depth knowledge of different blockchain use cases. After analyzing countless projects and finding recurring shortcomings we decided to raise the standards to a new level while educating businesses who want to learn about the opportunities of Web3. This is our way to contribute to the digital transformation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='about_inner_div3'>
                    <div className='about_h4_div2' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='100'>
                        <h4>OUR</h4>
                        <b>TEAM</b>
                    </div>
                    <div className='solution_list_text_div6' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='100'>
                        <h4>Advisors & partners with a</h4>
                        <b>variety of backgrounds and skills</b>
                    </div>
                    <div className='about_card_main_div'>
                        {
                            team_obj?.map((v, i) => {
                                return (
                                    <>
                                        <div className='about_card_inner_div'>
                                            <div className='about_card_img_div'>
                                                <img src={v?.img} alt="" />
                                            </div>
                                            <div className='about_card_text'>
                                                <h2>{v?.name}</h2>
                                                <p>{v?.pos}</p>
                                            </div>
                                            <div className='about_card_icon_div'>
                                                <div className='about_card_icon_inner'>
                                                    <EmailOutlined className='about_div_icons' />
                                                </div>
                                                <div className='about_card_icon_inner'>
                                                    <FaTelegramPlane className='about_div_icons' />
                                                </div>
                                                <div className='about_card_icon_inner'>
                                                    <GrLinkedinOption className='about_div_icons' />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='about_inner_div4'>
                    <div className='about_located_main_div'>
                        <div className='about_located_img'>
                            <img src={about_global_img} alt="" />
                        </div>
                        <div className='about_located_text_div'>
                            <div>
                                <div className='about_h4_div3'>
                                    <h4>LOCATED </h4>
                                    <b>GLOBALY</b>
                                </div>
                                <div className='about_located_inner_text' >
                                    <p>We are a global company that partners with organizations around the world to provide innovative solutions to complex challenges. Our team is comprised of experts from diverse backgrounds who are passionate about helping our clients reach their goals. We focus on developing and implementing strategies that drive growth and success both on a local and worldwide scale.</p>
                                </div>
                            </div>
                            <div className='about_located_icon_div'>
                                <div className='about_inner_icon_div'>
                                    <div><BsClock className='about_located_icon' /></div>
                                    <div className='about_inner_p_div'>
                                        <p>
                                            Covering most timezones
                                        </p>
                                    </div>
                                </div>
                                <div className='about_inner_icon_div'>
                                    <div><CiFlag1 className='about_located_icon' /></div>
                                    <div className='about_inner_p_div'>
                                        <p>
                                            Working with teams of diverse backgrounds
                                        </p>
                                    </div>
                                </div>
                                <div className='about_inner_icon_div'>
                                    <div><FaMapPin className='about_located_icon' /></div>
                                    <div className='about_inner_p_div'>
                                        <p>
                                            Based in Zug, Switzerland
                                        </p>
                                        <img src={switzerland_img} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='technologies_main_div2'>
                    <div className="technologies_heading_div" data-aos="fade-right" data-aos-duration='1500' data-aos-delay='100'>
                        <h3>OUR <b> PARTNERS</b></h3>
                        <p><span className='provide'>Benefit from our outstanding </span> corporate network</p>
                    </div>
                    <div className="images_div2">
                        {
                            partner_obj?.map((v, i) => {
                                return (
                                    <>
                                        <div className='img_div2' data-aos="fade-right" data-aos-duration='1500' data-aos-delay='100'>
                                            <img width={v?.width} src={v?.img} alt="" />
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='schedule_main_div'>
                    <Schedule heading="SCHEDULE A CALL OR" bold="CONTACT US NOW" heading2="We'd love to" bold2=' hear about your project!' />
                </div>
            </div>
        </>
    )
}
export default About
